import { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { Button, Dialog, Input } from "antd-mobile";
import useNavigation from "../../hooks/useNavigation";
import PageWrap from "../components/PageWrap";
import PageHeader, { headerHeight } from "../components/PageHeader";
import { useStores } from "../../models";
import { ToastError, ToastSuccess } from "../../components/Toast";
import { amountFormat } from "../../utils";
import { PayPasswordModal } from "../../components/Wallet";

const ScrollArea = styled.div`
  height: calc(100% - ${headerHeight});
  overflow: auto;
  background: #fff;
  padding: 12px;
`;

const Field = styled.div`
  margin-bottom: 16px;
`;

const Label = styled.div`
  font-size: 13px;
  color: #666;
  margin-bottom: 6px;
`;

const Balance = styled.div`
  color: #1c9cea;
  font-size: 14px;
  margin: 8px 0 16px;
`;

const Transfer = () => {
  const { goBack, navigate, params } = useNavigation();
  const { walletStore, userStore } = useStores();
  const userID = params?.user_id;
  const [loading, setLoading] = useState(false);
  const [address, setAddress] = useState("");
  const [amount, setAmount] = useState("");
  const [note, setNote] = useState("");
  const [pwdVisible, setPwdVisible] = useState(false);
  const { balance, pay_pwd } = walletStore;

  useEffect(() => {
    walletStore.getWalletInfo();
  }, [walletStore]);

  useEffect(() => {
    if (userID) {
      const user = userStore.users.get(String(userID));
      if (user) setAddress(user.username || "");
    }
  }, [userID, userStore.users]);

  const validateForm = () => {
    const newAmount = amountFormat(amount);
    setAmount(newAmount);
    if (!address) {
      ToastError("请输入正确账号或手机号");
      return false;
    }
    if (!Number(newAmount)) {
      ToastError("请输入正确数量");
      return false;
    }
    if (Number(newAmount) > Number(balance)) {
      ToastError("余额不足");
      return false;
    }
    return true;
  };

  const transfer = () => {
    const newAmount = amountFormat(amount);
    Dialog.confirm({
      title: "再次确认是否转账",
      content: `转账数量 : ${newAmount}`,
      confirmText: "确定",
      cancelText: "取消",
      onConfirm: () => {
        const isPhone = /^1\d{10}$/.test(address);
        const payload: any = {
          amount: Number(newAmount),
          note,
        };
        if (isPhone) payload.phone = address;
        else payload.username = address;

        const user = userID ? userStore.users.get(String(userID)) : null;
        if (user?.trade_no) {
          payload.appKey = user.appKey || "";
          payload.data = user.data || "";
          payload.path = user.path || "";
          payload.sign = user.sign || "";
          payload.trade_no = user.trade_no || "";
        }

        setLoading(true);
        walletStore.publicTransferNew(
          payload,
          async () => {
            await walletStore.getWalletInfo();
            ToastSuccess("转账成功！");
            setLoading(false);
            goBack(-1);
          },
          (error: any) => {
            ToastError(error?.message || "转账失败");
            setLoading(false);
          }
        );
      },
    });
  };

  const onTransfer = () => {
    if (!validateForm()) return;
    if (pay_pwd) setPwdVisible(true);
    else {
      Dialog.confirm({
        title: "提示",
        content: "请先绑定支付密码",
        confirmText: "前往绑定",
        cancelText: "之后再说",
        onConfirm: () => navigate("SettingPayNumber"),
      });
    }
  };

  return (
    <PageWrap>
      <PageHeader title="转账" />
      <ScrollArea>
        <Balance>可用余额：{balance} 喜鹊币</Balance>
        <Field>
          <Label>收款账号 / 手机号</Label>
          <Input
            value={address}
            onChange={setAddress}
            placeholder="请输入账号或手机号"
            style={{ background: "#f7f8ff", padding: 8 }}
          />
        </Field>
        <Field>
          <Label>转账数量</Label>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <Input
              value={amount}
              onChange={setAmount}
              placeholder="请输入数量"
              style={{ background: "#f7f8ff", padding: 8, flex: 1 }}
            />
            <Button
              size="mini"
              color="primary"
              fill="outline"
              onClick={() => setAmount(String(balance))}
            >
              全部
            </Button>
          </div>
        </Field>
        <Field>
          <Label>备注</Label>
          <Input
            value={note}
            onChange={setNote}
            placeholder="选填"
            style={{ background: "#f7f8ff", padding: 8 }}
          />
        </Field>
        <Button color="primary" block loading={loading} onClick={onTransfer}>
          确认转账
        </Button>
      </ScrollArea>
      <PayPasswordModal
        visible={pwdVisible}
        setVisible={setPwdVisible}
        callBack={(ok) => ok && transfer()}
      />
    </PageWrap>
  );
};

export default observer(Transfer);
